import {
	BaseError,
} from './BaseError';

export class GetSpecificationLotsOfferError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
